export default {
    edit: "編集",
    location: "場所 + 利用規約",
    filter: "フィルター"
}
